/* eslint-disable react/no-unknown-property */
import React, { Component } from 'react';

import { Grid, GridItem } from 'react-scale/components/website/big/main/Grid';
import List from 'react-scale/components/website/big/open-datasets/shared/interactive-car/List';
import NuscenesCar from 'react-scale/components/website/big/open-datasets/nuscenes/Car';
import PandasetCar from 'react-scale/components/website/big/open-datasets/pandaset/Car';
import WaterlooCar from 'react-scale/components/website/big/open-datasets/waterloo/Car';

import { mq } from 'react-scale/components/website/big/Themes';

class InteractiveCar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sensorHighlight: ''
    };
  }

  updateSensor = sensor => {
    this.setState({ sensorHighlight: sensor });
  };

  render() {
    const { sensorHighlight } = this.state;
    const { dataset, background, items } = this.props;

    return (
      <div className="mt-20 text-black interactive-car-container">
        <Grid margin={{ xl: 0, lg: 0, md: 0, xs: 0 }} vAlign="center">
          <GridItem lg="1 / 5" xl="1 / 5" md="1 / 5">
            <List
              onSensorHover={this.updateSensor}
              sensorHighlight={sensorHighlight}
              items={items}
            />
          </GridItem>
          <GridItem xl="5 / 13" lg="5 / 13" md="5 / 9">
            <div className="interactive">
              <div className="car-wrapper">
                <div className="car">
                  {dataset === 'nuscenes' && (
                    <NuscenesCar
                      onSensorHover={this.updateSensor}
                      className={sensorHighlight}
                      items={items}
                    />
                  )}
                  {dataset === 'pandaset' && (
                    <PandasetCar
                      onSensorHover={this.updateSensor}
                      className={sensorHighlight}
                      items={items}
                    />
                  )}
                  {dataset === 'waterloo' && (
                    <WaterlooCar
                      onSensorHover={this.updateSensor}
                      className={sensorHighlight}
                      items={items}
                    />
                  )}
                </div>
              </div>
            </div>
          </GridItem>
        </Grid>
        <style jsx>{`
          .interactive-car-container {
            position: relative;
          }
          @media (min-width: ${mq.lg}) {
            .interactive-car-container:before {
              content: '';
              position: absolute;
              top: 50%;
              left: 34.8%;
              width: 100vw;
              height: 100%;
              transform: translateY(-50%);
              background: ${background};
              opacity: 0.5;
              z-index: 0;
            }
          }
          @media (min-width: ${mq.xl}) {
            .interactive-car-container:before {
              left: 34.6%;
            }
          }

          .car-wrapper {
            position: relative;
            margin: calc(4rem) 0 0;
          }
          @media (min-width: ${mq.lg}) {
            .car-wrapper {
              margin: 0;
            }
          }
          .car-wrapper:before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: ${background};
            z-index: 0;
          }
          @media (min-width: ${mq.lg}) {
            .car-wrapper:before {
              width: 100vw;
              left: -20px;
              content: initial;
            }
          }

          .interactive {
            position: relative;
          }
          .interactive .car {
            position: relative;
            width: 280px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            z-index: 10;
          }
          @media (min-width: ${mq.md}) {
            .interactive .car {
              width: 400px;
            }
          }
          @media (min-width: ${mq.lg}) {
            .interactive .car {
              width: 500px;
            }
          }
          @media (min-width: ${mq.xl}) {
            .interactive .car {
              width: 820px;
            }
          }
        `}</style>
      </div>
    );
  }
}

export default InteractiveCar;
